import React, {Component} from 'react'
import PropTypes from 'prop-types'

import './SlideshowControls.scss'

import SlideNavigation from './SlideNavigation'
import SlideshowProgress from './SlideshowProgress'

export default class SlideshowControls extends Component {

  static propTypes = {
    corePlayerConnection: PropTypes.object.isRequired,
    currentSlide: PropTypes.number.isRequired,
    currentTime: PropTypes.number.isRequired,
    currentTotalTime: PropTypes.number.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    isStart: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired
  }
  state = {
    currentSlide: 0
  }

  setCurrentSlide(currentSlideIndex){
    this.setState({
      currentSlide: currentSlideIndex
    })
  }

  playToNextHold = () => {
    const {isPlaying, corePlayerConnection} = this.props
    if (isPlaying) {
      corePlayerConnection.jumpToNextHold()
    } else {
      corePlayerConnection.playToNextHold()
    }
  }

  previousSlide = () => {
    const {
      currentSlide,
      corePlayerConnection
    } = this.props

    corePlayerConnection.pause()
    if (corePlayerConnection.currentSlideTime > 0) {
      corePlayerConnection.jumpToPreviousHold()
    } else if (currentSlide > 0) {
      corePlayerConnection.jumpToPreviousSlide()
    }
  }

  restart = () => {
    this.props.corePlayerConnection.changeAbsoluteTime(0)
    this.playToNextHold()
  }

  render() {
    const {currentTime, currentTotalTime, isStart, isEnd, numberOfSlides} = this.props
    const {currentSlide} = this.state
    return (
      <div styleName="slideshow-controls">
        <SlideNavigation
          isStart={isStart}
          isEnd={isEnd}
          onNextSlide={this.playToNextHold}
          onPreviousSlide={this.previousSlide}
          onRestart={this.restart}
        />
        <Seperator />
        <SlideshowProgress
          currentSlide={currentSlide}
          totalSlides={numberOfSlides}
          currentTime={currentTime}
          currentTotalTime={currentTotalTime}
        />
      </div>
    )
  }
}

const Seperator = () => (<span>&nbsp;|&nbsp;</span>)
